export default function formatarMoeda({
  valor,
  moeda = 'BRL',
  lingua = 'pt-BR',
}: {
  valor?: number | string;
  moeda?: string;
  lingua?: string;
}) {
  return (valor || 0)?.toLocaleString(lingua, {
    style: 'currency',
    currency: moeda,
  });
}
